import script from "./IntellectualAboutTab.vue?vue&type=script&setup=true&lang=js"
export * from "./IntellectualAboutTab.vue?vue&type=script&setup=true&lang=js"

import "./IntellectualAboutTab.vue?vue&type=style&index=0&id=c2d843d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2d843d0"]])

export default __exports__